import { MouseEventHandler } from 'react'
import styles from './styles.module.css'

interface SecondaryButtonProps {
	buttonName: string
	onClick: MouseEventHandler
	disabled?: boolean
	style?: React.CSSProperties
	children?: React.ReactNode
	cyLabel?: string // Add this new prop
}

export default function SecondaryButton({
	buttonName,
	disabled,
	onClick,
	style,
	children,
	cyLabel, // Add this parameter
}: SecondaryButtonProps) {

	return (
		<button
			onClick={onClick}
			disabled={disabled}
			className={styles.secondaryButton}
			style={style}
			data-cy={cyLabel} // Add this data attribute
		>
			<span className={styles.secondaryButtonText}>{children || buttonName}</span>
		</button>
	)
}
